import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigate from '../../../../util/Navigate';
import Glitch from 'glitch-javascript-sdk';
import Publisherheader from '../../component/layout/publisherheader';

const PublisherDashboard = () => {
    const [community, setCommunity] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        setIsLoading(true);

        if (!Glitch.util.Session.isLoggedIn() && typeof window !== 'undefined') {
            navigate(Navigate.authLogin());
        }

        Glitch.api.Communities.list({ roles: [1, 2], order_by: 'created_at' })
            .then(response => {
                if (response.data.data.length > 0) {
                    setCommunity(response.data.data[0]);
                }
            })
            .catch(error => {
                console.error("Error fetching community data:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);


    const menuItems = [
        {
            label: "Chat",
            icon: "far fa-comments",
            action: () => navigate(Navigate.titlesChatPage()),
            description: "Chat with our AI about your marketing needs.",
            color: "bg-gradient-primary"
        },
        {
            label: "Find Influencers",
            icon: "fa-bullhorn",
            action: () => navigate(Navigate.campaignsPage()),
            description: "Start an influencer campaign to market your game.",
            color: "bg-gradient-danger"
        },
        {
            label: "Automate Social Media",
            icon: "fa-robot",
            action: () => navigate(Navigate.schedulerListPage()),
            description: "Schedule and manage your social media posts efficiently.",
            color: "bg-gradient-info"
        },
        {
            label: "Build A Community",
            icon: "fa-users",
            action: () => navigate(Navigate.communitiesAdminListPage()),
            description: "Create a forum-like system for users to engage around your game.",
            color: "bg-gradient-warning"
        },
        {
            label: "News Letter",
            icon: "fa-newspaper",
            action: () => navigate(Navigate.newsletterListPage()),
            description: "Keep your audience updated with game-related news and updates.",
            color: "bg-gradient-success"
        },
        {
            label: "Media Kit",
            icon: "fa-photo-video",
            action: () => navigate(Navigate.mediakitsPublishersListPage()),
            description: "Prepare promotional materials for your game.",
            color: "bg-gradient-purple"
        },
        {
            label: "Find Testers",
            icon: "fa-vial",
            action: () => navigate(Navigate.playtestingPublishersListPage()),
            description: "Recruit testers to improve your game's quality.",
            color: "bg-gradient-indigo"
        },
        {
            label: "Access Analytics",
            icon: "fa-chart-line",
            action: () => navigate(Navigate.reportsMainPage()),
            description: "Analyze performance metrics and insights for your campaigns.",
            color: "bg-gradient-teal"
        },
    ];

    return (
        <>
            <Publisherheader position={"relative"} />
            
            {/* Hero Section */}
            <section className="pageheader-section-min bg-dark-overlay" style={{
                backgroundImage: 'linear-gradient(rgba(8, 14, 55, 0.9), rgba(8, 14, 55, 0.9))',
                padding: '80px 0 60px'
            }}>
                <div className="container text-white">
                    <div className="section-wrapper text-center text-white">
                        <h2 className="pageheader-title mb-3">Dashboard</h2>
                        <p className="lead mb-4">Welcome to your command center! Manage all aspects of your game marketing and community from one place.</p>
                        
                        {community?.name && (
                            <div className="community-badge d-inline-block px-3 py-2 rounded-pill bg-primary bg-opacity-10 border border-primary border-opacity-25">
                                <i className="fas fa-users me-2"></i>
                                Active Community: {community.name}
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Dashboard Content */}
            <div className="container ">
                {isLoading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading your dashboard...</p>
                    </div>
                ) : (
                    <>
                       

                       
                        
                        <div className="row g-4">
                            {menuItems.map((item, index) => (
                                <div key={index} className="col-md-6 col-lg-4 col-xl-3">
                                    <div 
                                        className={`card feature-card border-0 shadow-sm h-100 hover-lift ${item.color}`}
                                        style={{ 
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            minHeight: '220px'
                                        }}
                                        onClick={item.action}
                                    >
                                        <div className="card-body d-flex flex-column p-4">
                                            <div className={`icon-rounded mb-3 ${item.color.replace('bg-gradient-', 'bg-')} bg-opacity-10`}>
                                                <i className={`fas ${item.icon} fa-2x text-black`}></i>
                                            </div>
                                            <h5 className="card-title mb-2">{item.label}</h5>
                                            <p className="card-text text-muted flex-grow-1">{item.description}</p>
                                            <div className="mt-auto">
                                                <span className="text-white small fw-bold">
                                                    Get started <i className="fas fa-arrow-right ms-1"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                         {/* Main Features Grid */}
                         <div className="section-header mt-5 mb-4">
                            <h3 className="section-title">Other Items</h3>
                         
                        </div>

                         {/* Quick Stats Section - Placeholder for future stats */}
                         <div className="row mb-5 g-4 text-white">
                           
                            <div className="col-md-4">
                                <div className="card bg-dark border-0 shadow-sm h-100">
                                    <div className="card-body text-center">
                                        <div className="icon-circle bg-info bg-opacity-10 text-info mb-3">
                                            <i className="fas fa-question-circle fa-2x"></i>
                                        </div>
                                        <h5 className="card-title text-white">Help Center</h5>
                                        <p className="card-text text-white">Get support when needed</p>
                                        <button 
                                            onClick={() => navigate(Navigate.publishersTutorialsPage())}
                                            className="btn btn-sm btn-outline-info mt-2"
                                        >
                                            Get Help
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Recent Activity Section - Placeholder */}
                        <div className="mt-5 pt-4">
                            <div className="section-header mb-4">
                                <h3 className="section-title">Recent Activity</h3>
                                <p className="section-subtitle text-white">Your latest actions and updates</p>
                            </div>
                            <div className="card bg-dark border-0 shadow-sm">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <p className="mb-0 text-muted">No recent activity yet</p>
                                        <button className="btn btn-sm btn-outline-secondary">
                                            View All Activity
                                        </button>
                                    </div>
                                    <div className="text-center py-4">
                                        <i className="fas fa-clock fa-3x text-muted mb-3"></i>
                                        <p className="text-muted">Your recent activities will appear here</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* Custom CSS for this component */}
            <style jsx>{`
                .icon-circle {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                }
                
                .icon-rounded {
                    width: 50px;
                    height: 50px;
                    border-radius: 12px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }
                
                .feature-card {
                    transition: all 0.3s ease;
                    border: 1px solid rgba(255,255,255,0.05);
                    background: rgba(35, 42, 92, 0.5);
                }
                
                .feature-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.2);
                }
                
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #4e54c8 0%, #8f94fb 100%);
                }
                
                .bg-gradient-danger {
                    background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
                }
                
                .bg-gradient-info {
                    background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
                }
                
                .bg-gradient-warning {
                    background: linear-gradient(135deg, #f46b45 0%, #eea849 100%);
                }
                
                .bg-gradient-success {
                    background: linear-gradient(135deg, #0575e6 0%, #021b79 100%);
                }
                
                .bg-gradient-purple {
                    background: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
                }
                
                .bg-gradient-indigo {
                    background: linear-gradient(135deg, #396afc 0%, #2948ff 100%);
                }
                
                .bg-gradient-teal {
                    background: linear-gradient(135deg, #00b4db 0%, #0083b0 100%);
                }
                
                .hover-lift:hover {
                    transform: translateY(-5px);
                }
                
                .community-badge {
                    transition: all 0.3s ease;
                }
                
                .community-badge:hover {
                    background-color: rgba(255,0,82,0.2) !important;
                    transform: translateY(-2px);
                }
                
                @media (max-width: 767.98px) {
                    .pageheader-section-min {
                        padding: 60px 0 40px !important;
                    }
                    
                    .feature-card {
                        min-height: auto !important;
                    }
                }
            `}</style>
        </>
    );
};

export default PublisherDashboard;